import './tableAddMenu.scss';
import { ReactNode } from 'react';
import { MdAdd, MdOutlinePlaylistAdd } from 'react-icons/md';
import { IListElement } from '@srm/ui/types/IListElement';

/** Класс панели меню «Добавить» (`popoverProps.className`): длинные имена наборов переносятся, а не растягивают панель. */
export const TABLE_ADD_MENU_CLASS = 'table-add-menu';

export interface ITableAddChoice {
    value: string;
    label: string;
    handler: () => void;
}

/** Значок способа добавления: своя пустая строка — «плюс», набор из справочника — «список с плюсом». */
export const tableAddChoiceIcon = (value: string, size = 17): ReactNode =>
    value === 'row' ? <MdAdd size={size} aria-hidden /> : <MdOutlinePlaylistAdd size={size} aria-hidden />;

/**
 * Пункты меню «Добавить»: своя строка первой, наборы из справочника — за ней. От двух наборов они собраны в группу
 * «Из справочника» с подписью: тогда понятно, что пункты — источники одних строк, а не разные действия.
 */
export const tableAddMenuItems = (ownRow: ITableAddChoice | undefined, sets: ITableAddChoice[]): IListElement[] => {
    const grouped = sets.length > 1;
    return [
        ...(ownRow ? [{ ...ownRow, startAdornment: tableAddChoiceIcon(ownRow.value) }] : []),
        ...(grouped ? [{ value: 'formData-title', label: 'Из справочника', isTitle: true, separated: !!ownRow }] : []),
        ...sets.map((set, index): IListElement => ({
            ...set,
            startAdornment: tableAddChoiceIcon(set.value),
            group: grouped ? 'formData' : undefined,
            separated: !grouped && !!ownRow && index === 0,
        })),
    ];
};
